import React from "react";
import PropTypes from "prop-types";
import { Footer } from "./Footer";
import { Wrapper } from "./Wrapper";
import { LevelItem } from "./LevelItem";
import { MainTitle } from "./MainTitle";
import { SelectButton } from "./SelectButton";
import { updateLevelList, getSelectedLevel } from "./LevelSelector.utils";
import "./style.scss";

/**
 * LevelSelector:
 *  - List of levels will be displayed
 *  - You could select the desired level
 */
export function LevelSelectorOld(props) {
  const [levels, updateLevels] = React.useState([]);

  React.useEffect(() => {
    updateLevels(updateLevelList(props.default)(props.levels));
  }, []);

  const onClickLevel = (value) => {
    updateLevels((list) => updateLevelList(value)(list));
  };

  const onClickSelect = (event) => {
    event.preventDefault();
    props.onSetLevel(getSelectedLevel(levels));
  };

  const renderLevelButton = (level, key) => (
    <LevelItem
      key={key}
      image={level.image}
      label={level.label}
      value={level.value}
      onClick={onClickLevel}
      selected={level.selected}
      description={level.description}
    />
  );

  const className = `levelSelector ${props.className}`;
  return (
    <Wrapper className={className}>
      <MainTitle className="levelSelector-title" title={props.title} />
      {levels.map(renderLevelButton)}
      <Footer className="levelSelector-footer">
        <SelectButton
          onClick={onClickSelect}
          className="levelSelector-footer-button"
          label={props.buttonText}
        />
      </Footer>
    </Wrapper>
  );
}

LevelSelectorOld.propTypes = {
  /**
   * List of levels for the simultion
   */
  levels: PropTypes.arrayOf(
    PropTypes.shape({
      /**
       * Label for level
       */
      label: PropTypes.string.isRequired,
      /**
       * value for level ( to uniquely identify level )
       */
      value: PropTypes.string.isRequired,
      /**
       * Image for level
       */

      image: PropTypes.string.isRequired,
      /**
       * description for level
       */
      description: PropTypes.string,
    })
  ).isRequired,
  /**
   * Level to be selectedBy default
   */
  default: PropTypes.string.isRequired,
  /**
   * Callback function to be executed when you click the Start Simulation Button
   */
  onSetLevel: PropTypes.func.isRequired,
  /**
   * title to set on MainTitle
   */
  title: PropTypes.string,
  /**
   * buttonText to set on SubmitButton
   */
  buttonText: PropTypes.string,
};
